import { UserManager, WebStorageStateStore } from 'oidc-client'
import Env from '../services/Env'

class Oidc {
  config: any
  userManager: any

  initialize() {
    this.config = {
      authority: Env.API_FINX_AUTH,
      automaticSilentRenew: true,
      client_id: Env.OIDC_CLIENT_ID,
      client_secret: Env.OIDC_CLIENT_SECRET,
      filterProtocolClaims: true,
      post_logout_redirect_uri: `${Env.CLIENT_ADDRESS}/inicio`,
      redirect_uri: `${Env.CLIENT_ADDRESS}/callback.html`,
      response_type: 'code',
      revokeAccessTokenOnSignout: false,
      silent_redirect_uri: `${Env.CLIENT_ADDRESS}/silent-renew.html`,
      scope: Env.OIDC_SCOPE || 'openid profile email api-ocr api-legacy',
      userStore: new WebStorageStateStore({ store: window.localStorage }),
      clockSkew: 7200,
    }

    this.userManager = new UserManager(this.config)
  }

  async getAccessToken() {
    const user = await this.userManager.getUser()
    if (user) {
      return user.access_token
    }
    const url = window.location.pathname
    await this.login(url)
  }

  async getUser() {
    return await this.userManager.getUser()
  }

  async login(returnUrl: String) {
    const url = `${Env.CLIENT_ADDRESS}${returnUrl}`
    return await this.userManager.signinRedirect({ state: url })
  }

  async logout() {
    return await this.userManager.signoutRedirect()
  }

  async redirectToHome() {
    window.location.replace('/inicio')
  }

}

export const Auth = new Oidc()
